import { Guid, IApiLink } from "@/types"

export interface ICreateAssetCategoryDto {
    name: string
}

export interface ICreateAssetCategory {
    dto: ICreateAssetCategoryDto
    createLink: IApiLink
}

export interface IGetAssetCategoryDto {
    id: string
    name: string
    description?: string | null
    division?: string | null
    divisionId?: Guid | null
}

export class AssetCategory {
    id: Guid
    name: string
    description?: string
    division?: string

    constructor(dto: IGetAssetCategoryDto) {
        this.id = dto.id
        this.name = dto.name
        this.description = dto.description || undefined
        this.division = dto.division || undefined
    }
}
